import { z } from 'zod';
import { decimalStringSchema, isoDateSchema, isoDateTimeSchema, uuidSchema } from './common.js';
import { groceryCategorySchema } from './enums.js';
export const pantryItemSchema = z.object({
    id: uuidSchema,
    householdId: uuidSchema.nullable(),
    name: z.string(),
    normalizedName: z.string(),
    quantity: decimalStringSchema.nullable(),
    unitCode: z.string().nullable(),
    unitText: z.string().nullable(),
    groceryCategory: groceryCategorySchema,
    expiresAt: isoDateSchema.nullable(),
    note: z.string().nullable(),
    /** Always at home: left out when a recipe or a meal plan goes onto a shopping list. */
    alwaysInStock: z.boolean().default(false),
    ingredientId: uuidSchema.nullable().optional(),
    productId: uuidSchema.nullable().optional(),
    productName: z.string().nullable().optional(),
    updatedAt: isoDateTimeSchema,
});
export const pantryItemWriteSchema = z.object({
    householdId: uuidSchema.nullable().optional(),
    name: z.string().trim().min(1).max(200),
    quantity: decimalStringSchema.nullable().optional(),
    unitCode: z.string().max(32).nullable().optional(),
    unitText: z.string().max(40).nullable().optional(),
    groceryCategory: groceryCategorySchema.optional(),
    expiresAt: isoDateSchema.nullable().optional(),
    note: z.string().trim().max(500).nullable().optional(),
    alwaysInStock: z.boolean().optional(),
    /** Product the item came from (scan to add). */
    productId: uuidSchema.nullable().optional(),
});
export const pantryMatchRequestSchema = z.object({
    /** Extra ingredients available beyond the stored pantry. */
    extraIngredients: z.array(z.string().trim().min(1).max(80)).max(50).default([]),
    householdId: uuidSchema.nullable().optional(),
    maxMissing: z.number().int().min(0).max(10).default(3),
    limit: z.number().int().min(1).max(50).default(20),
});
export const pantryMatchSchema = z.object({
    recipeId: uuidSchema,
    title: z.string(),
    coverThumbnailUrl: z.string().nullable(),
    totalTimeMinutes: z.number().int().nullable(),
    matchedIngredients: z.array(z.string()),
    missingIngredients: z.array(z.string()),
    matchRatio: z.number().min(0).max(1),
});
export const pantryMatchResponseSchema = z.object({
    matches: z.array(pantryMatchSchema),
});
//# sourceMappingURL=pantry.js.map